import { gql } from "@apollo/client";

export const typeDef = gql`
  type MetaTags {
    robots: String
    title: String
    keywords: String
    description: String
    canonicalUrl: String
  }

  type WebPage @cacheControl(maxAge: 300) {
    id: Int
    content: String
    style: String
    script: String
    metatags: MetaTags
  }

  type Query {
    webPage(path: String): WebPage
  }
`;

export const resolvers = {
  Query: {
    webPage: async (_parent, args, { dataSources }) => {
      const res = await dataSources.webPage.getPage(args.path);
      return {
        ...res,
        metatags: {
          robots: res.robots,
          canonicalUrl: res.canonical_url,
          ...res.values,
        },
      };
    },
  },
};
